import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionReindexPayload } from 'api/actions/revision-reindex/revision-reindex-payload';
import { RevisionReindexPathParameters } from 'api/actions/revision-reindex/revision-reindex-path-parameters';
import { RevisionReindexResponse } from 'api/actions/revision-reindex/revision-reindex-response';

type RevisionReindexQueryParameters = Record<string, any>;

/**
 * The path of the RevisionReindex action.
 */
export const revisionReindexActionPath = new SweetPath<keyof RevisionReindexPathParameters>(
  '/api/revision/reindex/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionReindex actions.
 */
export default function createRevisionReindexAction(axios: AxiosInstance) {
  return function revisionReindexAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionReindexPathParameters;
    query?: RevisionReindexQueryParameters;
    payload: RevisionReindexPayload;
  }) {
    const path = revisionReindexActionPath.insert(parameters);

    return axios.request<RevisionReindexResponse, RevisionReindexResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
